import { __rest } from "tslib";
import * as React from 'react';
import { useRoutes } from '../hooks';
/**
 * The component for defining the exclusive routes to be used.
 */
export const PiralRoutes = (_a) => {
    var { NotFound, RouteSwitch } = _a, props = __rest(_a, ["NotFound", "RouteSwitch"]);
    const paths = useRoutes();
    return React.createElement(RouteSwitch, Object.assign({ NotFound: NotFound, paths: paths }, props));
};
PiralRoutes.displayName = 'Routes';
//# sourceMappingURL=PiralRoutes.js.map